"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OptionInfoPart = exports.RichTextareaPart = exports.JsonEditorPart = exports.TagsPart = exports.FileUploadPart = exports.SwitchPart = exports.SliderPart = exports.RadioPart = exports.DatePart = exports.CheckboxPart = exports.SelectPart = exports.TextareaPart = exports.InputPart = exports.FormComponent = void 0;
exports.declareFormParts = declareFormParts;
const component_1 = require("./checkbox/component");
Object.defineProperty(exports, "CheckboxPart", { enumerable: true, get: function () { return component_1.CheckboxPart; } });
const component_2 = require("./date/component");
Object.defineProperty(exports, "DatePart", { enumerable: true, get: function () { return component_2.DatePart; } });
const component_3 = require("./file-upload/component");
Object.defineProperty(exports, "FileUploadPart", { enumerable: true, get: function () { return component_3.FileUploadPart; } });
const component_4 = require("./form/component");
Object.defineProperty(exports, "FormComponent", { enumerable: true, get: function () { return component_4.FormComponent; } });
const component_5 = require("./input/component");
Object.defineProperty(exports, "InputPart", { enumerable: true, get: function () { return component_5.InputPart; } });
const component_6 = require("./json-editor/component");
Object.defineProperty(exports, "JsonEditorPart", { enumerable: true, get: function () { return component_6.JsonEditorPart; } });
const component_7 = require("./optioninfo/component");
Object.defineProperty(exports, "OptionInfoPart", { enumerable: true, get: function () { return component_7.OptionInfoPart; } });
const component_8 = require("./radio/component");
Object.defineProperty(exports, "RadioPart", { enumerable: true, get: function () { return component_8.RadioPart; } });
const component_9 = require("./richtextarea/component");
Object.defineProperty(exports, "RichTextareaPart", { enumerable: true, get: function () { return component_9.RichTextareaPart; } });
const component_10 = require("./select/component");
Object.defineProperty(exports, "SelectPart", { enumerable: true, get: function () { return component_10.SelectPart; } });
const component_11 = require("./slider/component");
Object.defineProperty(exports, "SliderPart", { enumerable: true, get: function () { return component_11.SliderPart; } });
const component_12 = require("./switch/component");
Object.defineProperty(exports, "SwitchPart", { enumerable: true, get: function () { return component_12.SwitchPart; } });
const component_13 = require("./tags/component");
Object.defineProperty(exports, "TagsPart", { enumerable: true, get: function () { return component_13.TagsPart; } });
const component_14 = require("./textarea/component");
Object.defineProperty(exports, "TextareaPart", { enumerable: true, get: function () { return component_14.TextareaPart; } });
function declareFormParts(parted) {
    if (!parted) {
        component_4.FormComponent;
        component_5.InputPart;
        component_14.TextareaPart;
        component_9.RichTextareaPart;
        component_10.SelectPart;
        component_1.CheckboxPart;
        component_2.DatePart;
        component_8.RadioPart;
        component_11.SliderPart;
        component_12.SwitchPart;
        component_3.FileUploadPart;
        component_13.TagsPart;
        component_6.JsonEditorPart;
        component_7.OptionInfoPart;
    }
}
